const PLACE_PIN_ICON = `
<svg width="25" height="24" viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M12.0571 12.75C13.2998 12.75 14.3071 11.7426 14.3071 10.5C14.3071 9.25736 13.2998 8.25 12.0571 8.25C10.8145 8.25 9.80713 9.25736 9.80713 10.5C9.80713 11.7426 10.8145 12.75 12.0571 12.75Z" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" fill="none"/>
<path d="M12.0571 19.5C15.0571 16.5 18.0571 13.8137 18.0571 10.5C18.0571 7.18629 15.3708 4.5 12.0571 4.5C8.74342 4.5 6.05713 7.18629 6.05713 10.5C6.05713 13.8137 9.05713 16.5 12.0571 19.5Z" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" fill="none"/>
</svg>
`;

export default PLACE_PIN_ICON;
